/**
 * University of La Laguna
 * School of Engineering and Technology
 * Degree in Computer Engineering
 * Final Degree Project (TFG)
 *
 * @author Fabián González Lence <alu0101549491@ull.edu.es>
 * @since March 16, 2026
 * @file src/domain/enumerations/notification-type.ts
 * @desc Enumeration defining the types of notifications generated by the system.
 * @see {@link https://github.com/alu0101549491/TFG-Fabian-Gonzalez-Lence/tree/main/projects/5-TennisTournamentManager}
 * @see {@link https://typescripttutorial.net}
 */

/**
 * Represents the type/category of a system notification.
 */
export enum NotificationType {
  /** Registration has been confirmed (FR52). */
  REGISTRATION_CONFIRMED = 'REGISTRATION_CONFIRMED',
  /** A match has been scheduled (FR52). */
  MATCH_SCHEDULED = 'MATCH_SCHEDULED',
  /** A result has been entered for a match (FR52). */
  RESULT_ENTERED = 'RESULT_ENTERED',
  /** The order of play has been published (FR52). */
  ORDER_OF_PLAY_PUBLISHED = 'ORDER_OF_PLAY_PUBLISHED',
  /** A new announcement has been published (FR52). */
  ANNOUNCEMENT = 'ANNOUNCEMENT',
}

/**
 * Type guard to check if a value is a valid NotificationType.
 *
 * @param value - The value to check
 * @returns True if the value is a valid NotificationType
 */
export function isValidNotificationType(value: unknown): value is NotificationType {
  return Object.values(NotificationType).includes(value as NotificationType);
}

/** Array of all notification types for iteration. */
export const ALL_NOTIFICATION_TYPES = Object.values(NotificationType);
